'use client';

import { useEffect, useRef } from 'react';

import { FieldSettingsDrawer } from '@/components/FieldSettingsDrawer';
import { HtmlEditor } from '@/components/HtmlEditor';
import { Loading } from '@/components/Loading';
import { SendType } from '@/types';
import { IAddFields } from '@/types/template-type';
import { useViewModel } from '@/utils/bizify';

import { isEmptyHtml } from '@/utils/dom';

import { LeftPanel } from './LeftPanel';
import { DataCtrl } from './dataCtrl';
type Props = {
  isAddTerms?: boolean;
  type: SendType;
  isShow: boolean;
  onDataChange?: (data: IAddFields) => void;
  data: any;
  isEditTerms?: boolean;
};
export const TemplateAddFields = (props: Props) => {
  const { isAddTerms, type, isShow, onDataChange, data, isEditTerms } = props;
  const vm = useViewModel(DataCtrl);
  const initRef = useRef(false);
  const vmData = vm.$useSnapshot();
  const editorRef = useRef<any>();
  const { openSettingDrawer, selectedItem, fields, signers, currentSigner, contractType, initHtml, html, loading } =
    vmData;

  const isHtmlEmpty = isEmptyHtml(html);
  useEffect(() => {
    vm.setSelectItem(undefined);
  }, [isAddTerms]);
  const handleDataChange = () => {
    const data = {
      html: editorRef.current.getData(),
      fields: vm.$getState().fields,
      signers: vm.$getState().signers,
      contractType: vm.$getState().contractType
    };
    onDataChange && onDataChange(data);
  };
  useEffect(() => {
    if (!initRef.current && data) {
      initRef.current = true;
      vm.initData(data);
    }
  }, [data]);

  return (
    <div className={`w-full h-full flex flex-row ${isShow ? '' : 'hidden'}`}>
      {loading && <Loading />}
      <LeftPanel
        onContractTypeChange={(type) => {
          vm.setContractType(type);
          editorRef.current.deleteNotTermElement();
          handleDataChange();
        }}
        contractType={contractType}
        setCurrentSigner={vm.setCurrentSigner}
        currentSigner={currentSigner}
        signers={signers as any}
        selectedItem={selectedItem}
        sendType={type}
        changeSigner={(type, data) => {
          vm.changeSigner(type, data, editorRef);
          handleDataChange();
        }}
        fields={fields as any}
        isAddTerms={isAddTerms}
        isEditTerms={isEditTerms}
        onSelectItem={(item) => {
          vm.setSettingDrawer(false);
          editorRef.current.selectElement(item?.id);
        }}
        onFieldChange={(data) => {
          editorRef.current.modifyElement(data);
        }}
      />
      <div className="flex-1 relative ">
        <HtmlEditor
          ref={editorRef}
          initData={initHtml}
          onChange={(html, fields) => {
            if (initRef.current) {
              vm.setData(html, fields);
              handleDataChange();
            }
          }}
          onSelectionChange={(e) => isAddTerms && vm.setSelectItem(e)}
        />
        {isHtmlEmpty && (
          <div className="absolute top-[168px] w-full flex-col flex pr-[320px] items-center">
            <div
              onClick={() => {
                editorRef.current.focus();
              }}
            >
              <div className="w-[790px] px-20 text-[31px]/[42px] font-bold text-gray-300">
                Type here to draft your contract.
              </div>
              <div className="w-[790px] px-20 text-sm text-gray-500 mt-2">
                You can start drafting your contract by typing, paste the content
              </div>
              <div className="w-[790px] px-20 text-sm text-gray-500 font-bold">
                We recommend copy and pasting from Google Docs for consistent formatting.
              </div>
            </div>
            {/* <div className="mt-32 w-[560px]">
              <Upload
                description="Upload a DOCX or PDF file. Max file size is 5MB"
                accept=".pdf,.docx"
                className="h-[200px]"
                getFile={(file) => {
                  vm.getHtml(file);
                }}
              ></Upload>
            </div> */}
          </div>
        )}
        <FieldSettingsDrawer
          value={selectedItem}
          showInputType={selectedItem?.type === 'term'}
          open={openSettingDrawer && !isEditTerms}
          onValueChange={(item) => {
            selectedItem && editorRef.current?.modifyElement({ ...selectedItem, ...item });
          }}
        />
      </div>
    </div>
  );
};
